import { styled } from '@mui/material'
import React, { useState } from 'react'
import InputBoxOnChange from '../inputbox/InputBoxOnChange'
import { NextButton } from '../common/CommonStyled'
import { useAdLoginStore } from 'src/stores/AdLoginStore'
import { postFindPassword } from 'src/api/User'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const PageWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection: 'column',
    gap:'50px',

    position:'absolute',
    zIndex:1,
    width:'100%',
    height:'calc(100% - 90px)',
    top:0
}))

const HeaderWrapper = styled('span')(({theme})=>({
    fontWeight:'bold',
    fontSize:'38px',
    color:'white'
}))

const LoginForm = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    gap:'10px',

    backgroundColor:'white',
    padding:'32px',
    boxShadow: '3px 5px 15px 0px rgba(0, 0, 0, 0.15)',
    borderRadius:'5px',
    // width:'100%',
    minWidth:'420px'
}))

const TextBox = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',

    padding:'28px',
    fontSize: '14px',
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: '#F5F5F5',
    fontFamily: 'Pretendard',
    whiteSpace: 'nowrap',
    color:'#727272'
}))
  
  // 버튼 감싸는 컨테이너
  const ButtonContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    gap: '16px',
    width: '100%',
    flexDirection: 'column',
  }));

type miniTap = 'FindingPw' | 'Correct' | 'InCorrect'

const AdFindPwBox = () => {
    const [userName, setUserName] = useState("")
    const [userEmail, setUserEmail] = useState("")
    const [userId,setUserId] = useState('')
    const [currentPage,setCurrentPage] = useState<miniTap>('FindingPw')
    const [errorText,setErrorText] = useState('')
    const setField = useAdLoginStore((state)=>state.setField)

    const handleSubmit = async(id:string,name:string,email:string)=>{
        const response = await postFindPassword(id,name,email)
        if(response.status==="OK"){
            setCurrentPage('Correct');
        }
        else{
            if (response.status==="403"){
            setErrorText('* 관리자 승인이 필요한 계정입니다.')
            }
            else{
            setErrorText('* 입력하신 정보와 일치하는 계정이 없습니다.')
            }
            setCurrentPage('InCorrect')
        }
    }
    const onChangeId = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setUserId(e.target.value)
    }
    const onChangeName = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setUserName(e.target.value)
    }
    const onChangeEmail = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setUserEmail(e.target.value)
    }
  return (
    <PageWrapper>
        <HeaderWrapper>비밀번호 찾기</HeaderWrapper>
        <LoginForm>
            {currentPage === 'FindingPw' && 
            <>
            <span style={{textAlign:'left', width:'100%'}}>아이디</span>
            <InputBoxOnChange placeholder='아이디' value={userId ?? ""} onChange={onChangeId}/>
            <span style={{textAlign:'left', width:'100%', marginTop:'10px'}}>이름</span>
            <InputBoxOnChange placeholder='이름' value={userName} onChange={onChangeName}/>
            <span style={{textAlign:'left', width:'100%', marginTop:'10px'}}>등록된 이메일</span>
            <InputBoxOnChange placeholder='이메일' value={userEmail} onChange={onChangeEmail}/>
            <NextButton style={{marginTop:'20px'}} onClick={()=>handleSubmit(userId,userName,userEmail)}>임시 비밀번호 발급</NextButton>
            </>
            }
            {currentPage === 'Correct' &&
            <>
            <span style={{textAlign:'center', width:'100%', marginBottom:'6px'}}>아래 이메일로 임시 비밀번호를 발급했습니다.</span>
            <TextBox style={{marginBottom:'6px'}}>
            이메일 : {userEmail}
            </TextBox>
            <ButtonContainer>
              <NextButton onClick={()=>setField('tab','Login')}>로그인</NextButton>
            </ButtonContainer>
            </>}
            {currentPage === 'InCorrect' &&
            <>
            <ErrorOutlineIcon sx={{marginBottom:'14px'}}/>
            <span style={{textAlign:'center', width:'100%', marginBottom:'14px'}}>{errorText}</span>
            <ButtonContainer>
                <NextButton onClick={()=>setCurrentPage('FindingPw')}>비밀번호 다시 찾기</NextButton>
            </ButtonContainer>
            </>}
        </LoginForm>
    </PageWrapper>
  )
}

export default AdFindPwBox